<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
      <search-form-template
        :searchOptions="searchOptions"
        :toolConfig="toolConfig"
      ></search-form-template>
      <div class="centerBack">
        <div class="echartsArea">
          <echarts-template
            class="charts-box"
            ref="integralEcharts"
            :picOption="integralEcharts"
          >
          </echarts-template>
        </div>
        <table-template ref="store" :tableOptions="storeReportTable">
        </table-template>
      </div>
  </div>
</template>

<script>
import api from "@/config/api";
import searchFormTemplate from "@/components/template/searchFormTemplate";
import tableTemplate from "@/components/template/tableTemplate";
import echartsTemplate from "@/components/controls/echarts";
import { integralEcharts } from "@/page/home/options/reportEcharts";
export default {
  components: { searchFormTemplate, tableTemplate, echartsTemplate },
  data() {
    return {
      integralEcharts,
      title: "",
      indexShow: false,
      searchOptions: {
        simple: [
          {
          label: '门店名称',
          type: 'select',
          prop: 'storeId',
          data:[],
          url:api.system.seStore,
           },
        ],
           complex:[
              {
          label: '积分区间：',
          type: 'switch',
          prop: 'custom',
          span:12
           },
            {
          label: '均分区间',
          type: 'numberRange',
          prop: 'area',
          span:12
    
           },
             {
          label: '自选区间：',
          type: 'switch',
          prop: 'self',
          span:12
           },
             {
          label: '',
          type: 'numberRange',
          prop: 'money',
          span:12
           },
           ]
      },
      storeReportTable: {
        indexShow: true, //是否显示索引
        columns: [
          {
            label: "积分区间（单位：分）",
            prop: "storeName",
            width: "200",
            align: "center",
          },
          {
            label: "会员数（单位：个）",
            prop: "inventoryNum",
            width: "200",
            align: "center",
          },
        ],
        url: api.report.reportStatical,
      },
      toolConfig: [
        {
          label: "导出",
          code: "export",
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.title = document.title;
  },
  methods: {
    getData() {
      this.$nextTick(() => {
        this.$refs.integralEcharts.drawpic();
      });

      // this.$axios.fetchPost(api.report.staticalEchars).then(data => {
      //   if (data.code == 200) {
      //       console.log(this)
      //       // this.reportStatistics.charsOption.xAxis[0].data = data.data.storeName;
      //       // this.reportStatistics.charsOption.series[0].data = data.data.inventoryNum;
      //       // this.reportStatistics.charsOption.series[1].data = data.data.purchaseMoney;
      //       // this.reportStatistics.charsOption.series[2].data =data.data.retailMoney;
      //       this.$nextTick(() => {
      //           this.$refs.reportStatistics.drawpic();
      //       });
      //   }
      // }).catch(err => {
      //   this.$message({message: '请求失败！', type: 'error'})
      // })
    },
  },
};
</script>

<style scoped>
.page-template .centerBack {
  background: #fff;
  border-radius: 8px;
  padding: 25px;
}
.page-template .echartsArea {
  height: 500px;
  margin-bottom: 12px;
}
</style>


// WEBPACK FOOTER //
// src/page/report/member/integral/Distribution.vue